import script from "./UnsupportedPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./UnsupportedPage.vue?vue&type=script&setup=true&lang=ts"

import "./UnsupportedPage.vue?vue&type=style&index=0&id=7be5e9e0&lang=scss"

const __exports__ = script;

export default __exports__